import React, { Component, Fragment } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import HelloSign from 'hellosign-embedded';
import { get } from 'lodash';
import queryString from 'query-string';

import {
  getCreateTemplateUrl, displayToaster, hideToaster, toggleDrawer,
  clearLoadingState, GET_SIGN_URL, updateSignatureStatus, LOADING_PROP_TYPE,
  updateSignatureRequestStatus,
} from '../../../modules';
import { Drawer, DrawerHeader, LockedModalBody } from '../../../components';
import { APPLICATION_ROOT, ESIGN_DEV_MODE, SIGNED_STEP_NUMBER } from '../../../constants';

const DEFAULT_STATE = {
  file: undefined,
  drawerClasses: ['drawer', 'wide'],
  helloSignClient: undefined,
};

class SignDocument extends Component {
  constructor(props) {
    super(props);
    this.state = DEFAULT_STATE;

    this.handleDrawer = this.handleDrawer.bind(this);
  }

  componentDidUpdate(prevProps) {
    const {
      signatureRequest: {
        signUrl: {
          url,
          clientId,
          signatureId,
        },
      },
      selectedDocument: {
        id: requestId,
      },
    } = this.props;
    const { signatureRequest: { signUrl: { url: prevUrl } } } = prevProps;
    const container = document.getElementById('signature-container');
    let client;
    if (url && url !== prevUrl) {
      client = new HelloSign({ clientId });
      client.open(
        url,
        { container, skipDomainVerification: ESIGN_DEV_MODE }
      );
    }
    if (client) {
      client.on('sign', () => {
        this.props.displayToaster([
          'success',
          <FormattedMessage id="DOCUMENT_SIGNED" />,
          'app',
          5000,
          true,
        ]);
        // Trigger an event to notify ADHR 2.0 that a document has been signed.
        const signedDocs = new Set(window.asure.appSettings.esignature.onboarding.signedDocs);
        signedDocs.add(signatureId);
        window.asure.appSettings.esignature.onboarding.signedDocs = [...signedDocs];
        document.dispatchEvent(new Event('onboardingDocSigned'));
        this.handleDrawer();
        this.props.updateSignatureStatus(signatureId, 'Complete');
        const isOnboardingUrl = /^.*\/onboarding.aspx(?:\?[^?]*$)?$/i;
        const onboardingKey = get(window, 'asure.appSettings.esignature.onboarding.key') || queryString.parse(window.location.search).onboardingkey;
        if (!onboardingKey || !isOnboardingUrl.test(window.location.href)) {
          this.props.updateSignatureRequestStatus(requestId, SIGNED_STEP_NUMBER);
        }
        client.close();
      });
      client.on('ready', () => {
        this.setState({
          helloSignClient: client,
        });
      });
    }
  }

  handleDrawer() {
    const { drawerIsOpen } = this.props;
    const { helloSignClient } = this.state;

    if (helloSignClient && drawerIsOpen) helloSignClient.close();
    this.props.toggleDrawer(!drawerIsOpen);
    this.props.hideToaster('drawer');
    this.props.clearLoadingState(GET_SIGN_URL);
    // Allowing the drawer to close before resetting state makes for a cleaner animation
    setTimeout(() => this.setState(DEFAULT_STATE), 500);
  }

  render() {
    const { drawerClasses } = this.state;
    const { loading, drawerIsOpen } = this.props;
    const isLoading = loading[GET_SIGN_URL] === 'loading';
    const containerClasses = ['hello-sign-container', 'w-100', 'h-100'];
    if (isLoading) {
      containerClasses.push('loading');
    }
    return (
      <Fragment>
        <Drawer
          modalClassName={drawerClasses.join(' ')}
          toggle={this.handleDrawer}
          isOpen={drawerIsOpen}
          parentselector={APPLICATION_ROOT}
          backdrop={loading[GET_SIGN_URL] === 'loading' ? 'static' : true}
        >
          <DrawerHeader
            title="SIGN_THIS_DOCUMENT"
            toggle={this.handleDrawer.bind(this)}
          />
          <LockedModalBody className="p-4">
            <div id="signature-container" className={containerClasses.join(' ')} />
          </LockedModalBody>
        </Drawer>
      </Fragment>
    );
  }
}

SignDocument.defaultProps = {
  drawerIsOpen: false,
  selectedDocument: {},
};

SignDocument.propTypes = {
  selectedDocument: PropTypes.shape({
    id: PropTypes.string,
  }),
  signatureRequest: PropTypes.shape({
    signUrl: PropTypes.shape({
      url: PropTypes.string,
      clientId: PropTypes.string,
      signatureId: PropTypes.string,
    }).isRequired,
  }).isRequired,
  displayToaster: PropTypes.func.isRequired,
  loading: LOADING_PROP_TYPE.isRequired,
  drawerIsOpen: PropTypes.bool,
  toggleDrawer: PropTypes.func.isRequired,
  hideToaster: PropTypes.func.isRequired,
  clearLoadingState: PropTypes.func.isRequired,
  updateSignatureStatus: PropTypes.func.isRequired,
  updateSignatureRequestStatus: PropTypes.func.isRequired,
};

export default connect(
  (state) => {
    const { resources: { createTemplate, signatureRequest, docs: { selectedDocument } }, appState } = state;
    return {
      createTemplateData: createTemplate,
      signatureRequest,
      loading: appState.loading,
      drawerIsOpen: appState.drawer.isOpen,
      selectedDocument,
    };
  },
  dispatch => ({
    getCreateTemplateUrl: (file, companyId) => {
      dispatch(getCreateTemplateUrl(file, companyId));
      dispatch(hideToaster('app'));
    },
    displayToaster: args => dispatch(displayToaster(...args)),
    toggleDrawer: open => dispatch(toggleDrawer(open)),
    hideToaster: location => dispatch(hideToaster(location)),
    clearLoadingState: action => dispatch(clearLoadingState(action)),
    updateSignatureStatus: (signatureId, status) => dispatch(updateSignatureStatus(signatureId, status)),
    updateSignatureRequestStatus: (requestId, statusId) => dispatch(updateSignatureRequestStatus(requestId, statusId)),
  })
)(hot(module)(SignDocument));



// WEBPACK FOOTER //
// ./src/containers/routes/SignDocument/SignDocument.jsx